module.exports = __webpack_public_path__ + "static/media/addShiftToAbsenceSel.d4cece5e.svg";